import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import { BrowserRouter } from "react-router-dom";
import reportWebVitals from './reportWebVitals';

//Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <BrowserRouter>
  //   <App />
  // </BrowserRouter>

  <React.StrictMode>
    <App />
  </React.StrictMode>

);

reportWebVitals();
